import { Fragment, useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { Grid } from '@mui/material';
import { postDataToTheServer } from '../../../../helpers/api';
import AppURL from '../../../../constants/AppURL';
import { ToastWarning } from '../../../../constants/Toast';
import InputTextBox from '../../../../constants/InputTextBox';
import { EndBaseLine } from '../../../../constants/AppSpace';
import { Button } from '../../../../constants/Button';
import { handleChangeDate } from '../../../../helpers/handleChange';
import useFetchData from '../../../../helpers/useFetch';
import { FiscalYearOptions } from '../../../../constants/Options';
import DefaultSelectInputBox from '../../../../constants/DefaultSelectBox';
import { NepaliACDateFormat } from '../../../../constants/DateFormat';
import { useSidebar } from '../../../../helpers/sidebarClose';
import { ACCOUNT_RPT_DATE } from '../../../../store/orgSlice';
import { useDispatch } from 'react-redux';

interface BanaceSheetRptFormViewProps {
  setOnBalnSheetReport: any;
}
const BanaceSheetRptFormView: React.FC<BanaceSheetRptFormViewProps> = ({ setOnBalnSheetReport }) => {
  const { data } = useFetchData(AppURL.AccountURL + "account/report/fiscal/year/list/view/");
  const { closeSidebar } = useSidebar('balancesheet_report');
  const dispatch = useDispatch();
  const initialValues = {
    fiscal_year: "",
    from_date_n: "",
    to_date_n: "",
    range_from_date_n: "",
    range_to_date_n: "",
  };
  const { values, errors, touched, setFieldValue, isSubmitting, handleBlur, handleChange, handleSubmit } = useFormik({
    initialValues,
    enableReinitialize: true,
    onSubmit: async (values, action) => {
      const formData = new FormData();
      if (NepaliACDateFormat(values.from_date_n) >= NepaliACDateFormat(values.range_from_date_n) && NepaliACDateFormat(values.from_date_n) <= NepaliACDateFormat(values.range_to_date_n) && NepaliACDateFormat(values.to_date_n) <= NepaliACDateFormat(values.range_to_date_n) && NepaliACDateFormat(values.to_date_n) >= NepaliACDateFormat(values.range_from_date_n)) {
        const formData = new FormData();
        formData.append("from_date", values.from_date_n);
        formData.append("to_date", values.to_date_n);
        await postDataToTheServer(AppURL.AccountURL + `account/report/transaction/report/list/view/`, formData).then((res) => {
          setOnBalnSheetReport(res);
          closeSidebar();
          dispatch(ACCOUNT_RPT_DATE({
            date: "",
            date_from: values.from_date_n || "",  // Provide empty string if undefined
            date_to: values.to_date_n || ""       // Provide empty string if undefined
          }));
        });

      } else {
        ToastWarning({ message: "Please Check Your Fiscal Year" })
      }
    },
  });

  useEffect(() => {
    if (data) {
      const currentFiscalYearData = data?.data?.filter((item: any) => item?.is_current_fiscal === 1);
      if (currentFiscalYearData?.length > 0) {
        setFieldValue("fiscal_year", currentFiscalYearData[0]?.fiscal_year_id);
        setFieldValue("from_date_n", currentFiscalYearData[0]?.from_date_n);
        setFieldValue("to_date_n", currentFiscalYearData[0]?.to_date_n);
        setFieldValue("range_from_date_n", currentFiscalYearData[0]?.from_date_n);
        setFieldValue("range_to_date_n", currentFiscalYearData[0]?.to_date_n);
      }
    }
  }, [data]);
  const fiscalYearOptions = FiscalYearOptions(data?.data || []);
  return (
    <Fragment>
      <form onSubmit={handleSubmit}>
        <Grid container columnSpacing={3} rowSpacing={1}>
          <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
            <DefaultSelectInputBox
              label='Fiscal Year'
              options={fiscalYearOptions}
              optionSelect={(name, selectedOption) => {
                setFieldValue("from_date_n", selectedOption.from_date_n);
                setFieldValue("to_date_n", selectedOption.to_date_n);
                setFieldValue("range_from_date_n", selectedOption.from_date_n);
                setFieldValue("range_to_date_n", selectedOption.to_date_n);
                setFieldValue(name, selectedOption?.value);
              }}
              value={values.fiscal_year}
              required={false}
              placeholder='Select current fiscal'
              name='fiscal_year'
              handleBlur={() => {
                handleBlur({ target: { name: 'fiscal_year' } });
              }}
              touched={touched.fiscal_year}
              errors={errors.fiscal_year}
            />
          </Grid>
          <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
            <InputTextBox
              type='text'
              name='from_date_n'
              label='From Fiscal Date(B.S.)'
              handleChange={(e) => handleChangeDate(e, { setFieldValue, name: 'from_date_n' })}
              value={values.from_date_n}
              error={errors.from_date_n}
              handleBlur={handleBlur}
              touched={touched.from_date_n}
              required={true}
              placeholder='XXXX/XX/XX'
            />
          </Grid>
          <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
            <InputTextBox
              type='text'
              name='to_date_n'
              label='To Fiscal Date(B.S.)'
              handleChange={(e) => handleChangeDate(e, { setFieldValue, name: 'to_date_n' })}
              value={values.to_date_n}
              error={errors.to_date_n}
              handleBlur={handleBlur}
              touched={touched.to_date_n}
              required={true}
              placeholder='XXXX/XX/XX'
            />
          </Grid>
          <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
            <EndBaseLine top={18}>
              <Button btn_type='search' type='submit' el='button' />
            </EndBaseLine>
          </Grid>
        </Grid>
      </form>
    </Fragment>
  )
}

export default BanaceSheetRptFormView
